import { Component, OnInit ,Inject, Output, EventEmitter } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { OrdersService } from 'src/app/services/order-service';
import {MatDialog } from '@angular/material/dialog';
import { Router} from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { BussinssService } from 'src/app/services/bussinss-service';

@Component({
  selector: 'app-popup-order',
  templateUrl: './popup-order.component.html',
  styleUrls: ['./popup-order.component.css']
})
export class PopupOrderComponent implements OnInit {
  @Output()change: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(@Inject(MAT_DIALOG_DATA) private data: {OrderID: number},private dataService: DataService,
  private bussinssService :BussinssService, private matDialog:MatDialog,private orderService:OrdersService ,private router: Router) { }

  ngOnInit(): void {
  }

  cancel(){
    let a=location.hash;
    this.matDialog.closeAll();
this.orderService.setUpdateOrder
({
  OrderID: this.data.OrderID,
  IsDelivery:0,
  IsPickUp:0,
  IsSitting:0,
  PaymentType:1,
  MenuID:null,
  Count:null,
  Status:0,
  Note:null,
  IsAddress : 1,
  Address : null,
  Latitude : null,
  Longitude : null,
  IsGiftCard : null,
  GiftNumber:null,
  SumGift:null,
  card_mask : null,
  card_validity:null,


})
// (this.data.OrderID,0,0,0,1,
//  null,null,0,null,1,null,null,null,null,null,null,null,null)
 .subscribe((res:any)=>{

  this.orderService.order=null;
  this.dataService.endToppings.next(true);
  this.dataService.orderOpen.next(true);
  this.change.emit();
  sessionStorage.CATEGORY_FILTER="";
  let id:number=localStorage.ID;
  this.bussinssService.getBusinessEnName(Number(id)).subscribe((res: any) => {
    let nameEn=res;
  this.orderService.order=null;
this.dataService.endToppings.next(true);
this.change.emit();
let url: string = "/restaurant/" + nameEn;
this.router.navigateByUrl(url);
     });
    });
  }

  end()
  {
    this.matDialog.closeAll();
    //localStorage.ID=localStorage.ID_CATEGORY;
    this.router.navigate(['../yourOrder']);
  }

  close()
  {
    this.matDialog.closeAll();
  }
}
